/** Natural colour per crop (tomato red, chilli green, grape purple, banana gold, …). */
export const CROP_COLORS: Record<string, string> = {
  grape: '#7d3fa3',
  pomegranate: '#c0392b',
  citrus: '#e08519',
  banana: '#d7a017',
  tomato: '#d94436',
  chilli: '#3f9e2f',
  potato: '#a5793f',
  onion: '#a4517a',
  sugarcane: '#5f9a37',
  cotton: '#6f9a4a',
  'wheat-paddy': '#c3a033',
  'turmeric-ginger': '#cf9220',
}

export function cropColor(slug: string): string {
  return CROP_COLORS[slug] ?? '#159A3C'
}
